export function alphabetical(
    one: string | keyof any,
    another: string | keyof any
): number {
    return String(one).localeCompare(String(another))
}

export function isEmail(str: string): boolean {
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/email#Basic_validation
    const pattern =
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/

    return pattern.test(str)
}

export function sentenceCase(str: string): string {
    return str.replaceAll(/[-_]+/g, " ")
}
